import styled from 'styled-components';
import {TradingCard, FilterSection} from '../Trading/styles';

/**
 * Card de filtro compacto: evita padding duplo (OrangeAccentCard + FilterSection)
 * que deixava faixa vazia grande embaixo dos campos.
 */
export const DashboardFilterCard = styled(TradingCard)`
    && {
        padding: 0 !important;
        margin-bottom: 20px !important;
    }
`;

export const DashboardFilterSection = styled(FilterSection)`
    && {
        padding: 16px 18px 18px !important;
    }

    @media (min-width: 768px) {
        && {
            padding: 18px 22px 20px !important;
        }
    }
`;

/** Grade superior: 3 colunas em telas largas, mesma altura */
export const DashboardTopGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    gap: 18px;
    margin-bottom: 18px;
    width: 100%;
    min-width: 0;
    align-items: stretch;

    @media (min-width: 1200px) {
        grid-template-columns: repeat(3, 1fr);
        gap: 20px;
    }
`;

/** Linha inferior: estratégias (maior) + gráfico mensal */
export const DashboardSplitGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    gap: 18px;
    width: 100%;
    min-width: 0;

    @media (min-width: 992px) {
        grid-template-columns: minmax(0, 2fr) minmax(0, 1fr);
        gap: 20px;
        align-items: stretch;
    }
`;

/**
 * Envolve cards Bootstrap internos (ranking, gráficos) com tema escuro
 * alinhado ao restante do app.
 */
export const DashboardPanel = styled.div`
    min-width: 0;
    display: flex;
    flex-direction: column;
    align-self: stretch;
    height: 100%;

    /* wrapper interno dos componentes de ranking */
    & > div {
        flex: 1 1 auto;
        min-height: 0;
        display: flex;
        flex-direction: column;
        height: 100%;
    }

    .card {
        margin-bottom: 0 !important;
        flex: 1 1 auto;
        min-height: 0;
        height: 100%;
        display: flex;
        flex-direction: column;
        background: linear-gradient(
            145deg,
            rgba(26, 32, 58, 0.98) 0%,
            rgba(18, 22, 42, 1) 100%
        );
        border: 1px solid rgba(242, 146, 5, 0.28);
        border-radius: 16px;
        box-shadow:
            0 12px 40px rgba(0, 0, 0, 0.42),
            0 0 0 1px rgba(0, 0, 0, 0.18);
        overflow: hidden;
        transition: box-shadow 0.25s ease, transform 0.22s ease;

        &:hover {
            box-shadow:
                0 16px 48px rgba(0, 0, 0, 0.5),
                0 0 0 1px rgba(242, 146, 5, 0.2);
        }
    }

    .card-header {
        background: rgba(0, 0, 0, 0.25);
        border-bottom: 1px solid rgba(242, 146, 5, 0.2);
        color: rgba(245, 248, 255, 0.98);
        padding: 14px 18px;
        font-weight: 600;
        flex-shrink: 0;

        i {
            color: #f29205;
            margin-right: 8px;
        }

        .badge {
            font-weight: 700;
            border-radius: 20px;
        }

        .badge-success {
            background: linear-gradient(135deg, #1cc88a 0%, #13855c 100%);
            color: #fff;
        }

        .badge-danger {
            background: linear-gradient(135deg, #e74a3b 0%, #b8352a 100%);
            color: #fff;
        }
    }

    .card-body {
        color: rgba(230, 235, 250, 0.92);
        padding: 16px 18px 20px;
        flex: 1 1 auto;
        display: flex;
        flex-direction: column;
        min-height: 0;
    }

    /* Relatório de estratégias: tabela largura total do card; sem faixa nas laterais nem espaço acima */
    .card-body.dashboard-strategy-card-body {
        padding-left: 0 !important;
        padding-right: 0 !important;
        padding-top: 0 !important;
    }

    /* Encadeia altura para o empty state centralizar no eixo vertical */
    .card-body > .row {
        flex: 1 1 auto;
        min-height: 0;
        display: flex;
        flex-direction: column;
    }

    .card-body > .row > [class*="col"] {
        flex: 1 1 auto;
        min-height: 0;
        display: flex;
        flex-direction: column;
    }

    .card-body > [class*="col-"] {
        flex: 1 1 auto;
        min-height: 0;
        display: flex;
        flex-direction: column;
    }

    .card-body > div:not(.row):not([class*="col-"]) {
        flex: 1 1 auto;
        min-height: 0;
        display: flex;
        flex-direction: column;
    }

    .card-body .col-md-12 {
        flex: 1 1 auto;
        min-height: 0;
        display: flex;
        flex-direction: column;
    }

    .list-group-item {
        background: transparent;
        border-color: rgba(255, 255, 255, 0.08);
        color: rgba(230, 235, 250, 0.92);
    }

    .progress {
        background: rgba(255, 255, 255, 0.08);
        border-radius: 8px;
    }

    /* Gráfico mensal Highcharts — sem caixa branca */
    .trading-month-chart-wrap,
    .trading-month-chart {
        background: transparent !important;
    }

    .trading-month-chart .highcharts-container {
        font-family: Nunito, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif !important;
    }

    .trading-month-chart .highcharts-background {
        fill: transparent;
    }
`;
